import actionConstants from '../constants/';

const signupState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  UATMID: null,
  message: null,
  code: null,
  email: null,
  id: null,
  token:null
};

const edgeSignupState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  message: null,
  code: null,
  userEmail: null,
};

const emailVerificationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {}
};

const resendVerificationMailState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {}
};

const salesforceState = {
  access_token: '',
  instance_url: '',
  id: '',
  token_type: '',
  issued_at: '',
  signature: '',
  isSuccess: false,
  isFailure: false,
  error_code: '',
  error_message: '',
};

const resetPasswordWithTokenState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  message: null,
};

const initialState = {
  signupState: { ...signupState },
  salesforceState: { ...salesforceState },
  edgeSignupState: {...edgeSignupState},
  emailVerificationState: {...emailVerificationState},
  resendVerificationMailState: {...resendVerificationMailState},
  resetPasswordWithTokenState: {...resetPasswordWithTokenState}
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function signupReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.POST_SIGN_UP_REQUEST:
      return {
        ...state,
        signupState: {
          ...state.signupState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          UATMID: null,
          message: null,
          code: null,
          email: action?.payload?.email,
          id: action?.payload?.id
        },
      };

    case actionConstants.POST_SIGN_UP_SUCCESS:
      return {
        ...state,
        signupState: {
          ...state.signupState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          message: action.payload.body?.status,
          code: action.payload.body?.statusCode,
          email: action?.payload?.email,
          id: action?.payload?.id
        },
      };

    case actionConstants.POST_SIGN_UP_FAILURE:
      return {
        ...state,
        signupState: {
          ...state.signupState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          UATMID: null,
          message:  action?.payload?.body?.message,
          code: null,
          email: action?.payload?.email,
          id: action?.payload?.id
        },
      };

    case actionConstants.POST_SIGN_UP_CLEAR:
      return {
        ...state,
        signupState,
      };

      case actionConstants.POST_EMAIL_VERIFICATION_REQUEST:
        return {
          ...state,
          emailVerificationState: {
            ...state.emailVerificationState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {}
          },
        };
  
      case actionConstants.POST_EMAIL_VERIFICATION_SUCCESS:
        return {
          ...state,
          emailVerificationState: {
            ...state.emailVerificationState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action?.payload?.body
          },
        };
  
      case actionConstants.POST_EMAIL_VERIFICATION_FAILURE:
        return {
          ...state,
          emailVerificationState: {
            ...state.emailVerificationState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: action?.payload?.body,
          },
        };
  
      case actionConstants.POST_EMAIL_VERIFICATION_CLEAR:
        return {
          ...state,
          emailVerificationState,
        };

        case actionConstants.POST_RESEND_EMAIL_VERIFICATION_REQUEST:
          return {
            ...state,
            resendVerificationMailState: {
              ...state.resendVerificationMailState,
              isLoading: true,
              isSuccess: false,
              isFailure: false,
              data: action?.payload?.body
            },
          };
    
        case actionConstants.POST_RESEND_EMAIL_VERIFICATION_SUCCESS:
          return {
            ...state,
            resendVerificationMailState: {
              ...state.resendVerificationMailState,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action?.payload?.body
            },
            signupState:{
              ...state.signupState,
              token:action?.payload?.extra?.token
            }
          };
    
        case actionConstants.POST_RESEND_EMAIL_VERIFICATION_FAILURE:
          return {
            ...state,
            resendVerificationMailState: {
              ...state.resendVerificationMailState,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
              data: action?.payload?.body,
            },
          };
    
        case actionConstants.POST_RESEND_EMAIL_VERIFICATION_CLEAR:
          return {
            ...state,
            resendVerificationMailState,
          };

      case actionConstants.EDGE_ONBOARD_REQUEST:
        return {
          ...state,
          edgeSignupState: {
            ...state.edgeSignupState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            message: null,
            code: null,
            userEmail: action?.payload?.userEmail
          },
        };
  
      case actionConstants.EDGE_ONBOARD_SUCCESS:
        return {
          ...state,
          edgeSignupState: {
            ...state.edgeSignupState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            message: action.payload.body?.status,
            code: action.payload.body?.statusCode,
            userEmail: action?.payload?.extra?.userEmail
          },
        };
  
      case actionConstants.EDGE_ONBOARD_FAILURE:
        return {
          ...state,
          edgeSignupState: {
            ...state.edgeSignupState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            message:  action?.payload?.body?.message,
            code: null,
            userEmail: action?.payload?.extra?.userEmail,
            UATMID: action?.payload?.extra?.UATMID,
          },
        };
  
      case actionConstants.EDGE_ONBOARD_CLEAR:
        return {
          ...state,
          edgeSignupState,
        };

    case actionConstants.SALESFORCE_AUTH_REQUEST:
      return {
        ...state,
        salesforceState: {
          ...salesforceState,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.SALESFORCE_AUTH_SUCCESS:
      return {
        ...state,
        salesforceState: {
          ...state.salesforceState,
          ...action.payload.body,
          isSuccess: true,
          isFailure: false,
        },
      };

    case actionConstants.SALESFORCE_AUTH_FAILURE:
      return {
        ...state,
        salesforceState: {
          ...state.salesforceState,
          ...action.payload.body,
          isSuccess: false,
          isFailure: true,
        },
      };
      case actionConstants.SALESFORCE_AUTH_CLEAR:
        return {
          ...state,
          salesforceState
        };

    case actionConstants.RESET_PASSWORD_WITH_TOKEN_REQUEST:
      return {
        ...state,
        resetPasswordWithTokenState: {
          ...state.resetPasswordWithTokenState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          message: null,
        },
      };

    case actionConstants.RESET_PASSWORD_WITH_TOKEN_SUCCESS:
      return {
        ...state,
        resetPasswordWithTokenState: {
          ...state.resetPasswordWithTokenState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          message: action?.payload?.body?.message || 'Password reset successfully',
        },
      };

    case actionConstants.RESET_PASSWORD_WITH_TOKEN_FAILURE:
      return {
        ...state,
        resetPasswordWithTokenState: {
          ...state.resetPasswordWithTokenState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          message: action?.payload?.body?.message || 'Failed to reset password',
        },
      };

    case actionConstants.RESET_PASSWORD_WITH_TOKEN_CLEAR:
      return {
        ...state,
        resetPasswordWithTokenState,
      };

    default:
      return state;
  }
}
